import { fetch } from '@utils/utils';

import * as T from '@modules/inventoryCards/_inventoryCardsTypes';

export const defaultInventoryCard = {
  id: '1ee338c6-3eb6-4f79-ac0c-148d670f6280',
  created: '2018-05-02T11:23:20.519Z',
  updated: '2018-05-02T11:23:20.519Z'
};

const getInventoryCard = ({ addError }) => async (id: string): Promise<T.InventoryCard> => {
  try {
    const response: any = await fetch(`/metropolis/api/wa/cards/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.InventoryCard = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return defaultInventoryCard;
  }
};

export { getInventoryCard };



// WEBPACK FOOTER //
// ./src/modules/inventoryCards/_inventoryCardsActions.ts